<template>
    <!-- Adım 5: Ödeme. Banka 1 maaşı mevcut kilit + maaş ödemesi ekranlarıyla; harcırah ayrı dosyayla
         (Sterling Type = Harcırah). Tasarım: claude.ai/artifact/85Bw2aMArbf95DF7CgfJn5 -->
    <div>
        <div class="row">
            <div class="col-lg-6 mb-1">
                <b-card class="h-100 mb-0">
                    <h5 class="mb-1">Banka 1 maaşı</h5>
                    <div class="d-flex flex-wrap mb-1" style="gap:24px">
                        <div><div class="small">Kesinleşmiş</div><div class="h4 mb-0 font-weight-bolder text-success">{{ finalizedRows.length }}</div></div>
                        <div><div class="small">Toplam</div><div class="h4 mb-0 font-weight-bolder">{{ f(sum(finalizedRows, 'Banka1Odeme')) }} ₺</div></div>
                    </div>
                    <ol class="pl-1 mb-50">
                        <li>Maaşları <router-link :to="{ name: lockRoute }">Banka 1 Maaş Kilit</router-link> ekranından kilitleyin.</li>
                        <li>Maaş dosyasını <router-link :to="{ name: paymentRoute }">Maaş Ödemesi</router-link> ekranından oluşturup gönderin.</li>
                    </ol>
                    <div class="small text-muted">Maaş dosyası mevcut ekranlarla, diğer personelle aynı şekilde hazırlanır.</div>
                </b-card>
            </div>
            <div class="col-lg-6 mb-1">
                <b-card class="h-100 mb-0">
                    <h5 class="mb-1">Harcırah</h5>
                    <div class="d-flex flex-wrap mb-1" style="gap:24px">
                        <div><div class="small">Kesinleşmiş harcırah</div><div class="h4 mb-0 font-weight-bolder">{{ f(sum(harcirahRows, 'Harcirah')) }} ₺</div></div>
                        <div><div class="small">Atanmamış</div><div class="h4 mb-0 font-weight-bolder" :class="unassigned.length ? 'text-warning' : 'text-success'">{{ unassigned.length }} kişi</div></div>
                        <div><div class="small">Ödendi</div><div class="h4 mb-0 font-weight-bolder">{{ harcirahRows.filter(r => r.HarcirahPaidDate).length }} kişi</div></div>
                    </div>
                    <group-key-create v-model="groupKeyObject"></group-key-create>
                    <div class="small text-muted mt-50">Banka hesabı olarak açıklama tipi "HARCIRAH ÖDEMESİ" olan hesabı seçin; banka dosyasındaki açıklama hesaptan gelir.</div>
                    <v-executer class="mt-1" full-width variant="secondary" :loading="creating" :action="createAndAssign" :disabled="!groupKeyObject.Date || !groupKeyObject.CompanyBankAccountId || unassigned.length == 0">Dosya kimliği oluştur ve harcırahları ata</v-executer>
                </b-card>
            </div>
        </div>

        <b-card no-body class="mb-1">
            <div class="p-1 d-flex flex-wrap align-items-center" style="gap:8px">
                <h6 class="mb-0 mr-auto">Harcırah dosyaları</h6>
                <span class="small text-muted">Dosya oluşturma, gönderim ve banka sonucu
                    <router-link :to="{ name: groupKeyRoute }">Banka Dosyası Kimlikleri › Harcırah</router-link> sekmesinden yürütülür.</span>
            </div>
            <v-table ref="groups" :fields="groupFields" :items-provider="groupProvider" pagination="server" :settings="false"></v-table>
        </b-card>

        <b-card no-body class="p-50">
            <div class="row justify-content-end">
                <div class="col-auto">
                    <button class="btn btn-sm btn-outline-secondary" v-on:click="$emit('back')">Geri</button>
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import GroupKeyCreate from '@/views/employee-operations/excepted-r-salary-payment/components/GroupKeyCreate.vue'

const HARCIRAH_TYPE = 7 // GarantiSterlingUploadStatusType.Harcirah
const fmt = v => Number(v || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

export default {
    components: { BCard, GroupKeyCreate },
    props: {
        donem: { type: Object, default: () => ({ year: null, month: null }) },
        filter: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            rows: [],
            creating: false,
            groupKeyObject: { Date: null, CompanyBankAccountId: null },
            lockRoute: 'salary-lock',
            paymentRoute: 'employee-salary-payment',
            groupKeyRoute: 'advance-payment-group-key',
            // Banka Dosyası Kimlikleri sekmeleriyle aynı hücre bileşenleri (ortak görünüm).
            groupFields: [
                { name: 'Kimlik', key: 'GroupKey', tdClass: 'text-nowrap' },
                { name: 'Banka Detay', thClass: 'w-40', component: true, componentOptions: { name: 'advance-payment-group-key/BankDetail' } },
                { name: 'Detay', thClass: 'w-60', component: true, componentOptions: { name: 'advance-payment-group-key/AdvancePaymentGroupKey' } }
            ]
        }
    },
    mounted() {
        this.load()
    },
    computed: {
        finalizedRows() { return this.rows.filter(r => r.Finalized) },
        harcirahRows() { return this.finalizedRows.filter(r => r.Harcirah > 0) },
        unassigned() { return this.harcirahRows.filter(r => !r.HarcirahAssigned) }
    },
    methods: {
        f: fmt,
        sum(list, key) { return list.reduce((a, r) => a + (r[key] || 0), 0) },
        load() {
            EmployeeOperationsApi.DomesticDriverSalary.Table({ ...this.filter, PaginateRequest: { QueryParam: '' } }).then(res => {
                if (res.data.Success) this.rows = res.data.Data || []
                else this.$result(res)
            }).catch(err => this.$result(null, err))
        },
        groupProvider(data) {
            return EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyTable({ ...data, Type: HARCIRAH_TYPE })
        },
        async createAndAssign() {
            this.creating = true
            try {
                const res = await EmployeeOperationsApi.SalaryEffect.Assign.GroupKeyCreate(this.groupKeyObject.Date, this.groupKeyObject.CompanyBankAccountId, HARCIRAH_TYPE)
                if (!res.data.Success) { this.$result(res); this.creating = false; return }
                const assignRes = await EmployeeOperationsApi.DomesticDriverSalary.AssignHarcirah({
                    GroupKey: res.data.Data.GroupKey,
                    EmployeeSalaryGroupId: this.filter.EmployeeSalaryGroupId,
                    Month: this.filter.Month,
                    Year: this.filter.Year
                })
                this.$result(assignRes)
                this.groupKeyObject = { Date: null, CompanyBankAccountId: null }
                this.load()
                this.$refs.groups?.refresh?.()
            } catch (err) {
                this.$result(null, err)
            }
            this.creating = false
        }
    }
}
</script>
